import React, { FC } from 'react';
import { TWCPage } from '@components';

import { onboardingTestIDs } from '@constants';

import { OnboardingHomePageContent } from './OnboardingHomeContent/OnboardingHomeContent';

export const OnboardingHomePage: FC = () => (
  <TWCPage
    childIds={[
      onboardingTestIDs.onboardingHome.subscribeButton,
      onboardingTestIDs.onboardingHome.signInButton,
      onboardingTestIDs.onboardingHome.pageInfoSection,
    ]}
    firstFocus={onboardingTestIDs.onboardingHome.subscribeButton}
    hasBackground={false}
    pageID={onboardingTestIDs.pages.onboardingHomePage}
  >
    <OnboardingHomePageContent />
  </TWCPage>
);
